import React from "react";

const WhatsAppIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" fill="#25D366" />
        <path d="M12 2C6.48 2 2 6.48 2 12c0 1.77.47 3.48 1.35 4.99L2 22l5.16-1.35C8.67 21.53 10.3 22 12 22c5.52 0 10-4.48 10-10S17.52 2 12 2zm0 18c-1.58 0-3.07-.42-4.35-1.15l-.31-.18-3.22.84.86-3.13-.2-.32A7.963 7.963 0 014 12c0-4.41 3.59-8 8-8s8 3.59 8 8-3.59 8-8 8z" fill="#25D366" />
    </svg>
);

const HealthMapFileOverlay = ({ url, type, title, id, onClose, onShare }) => {
    if (!url) return null;

    const isPdf = url.toLowerCase().endsWith(".pdf") || url.includes("application/pdf");

    const handleDownload = async () => {
        try {
            const res = await fetch(url);
            const blob = await res.blob();
            const blobUrl = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = blobUrl;
            // Extract extension from URL or use default
            const extension = url.split('.').pop().split('?')[0] || "file";
            a.download = `${title || type || "document"}_${id || "file"}.${extension}`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(blobUrl);
        } catch (err) {
            console.error("Download failed:", err);
            // Fallback: open in new tab
            window.open(url, "_blank");
        }
    };

    const handlePrint = () => {
        const iframe = document.getElementById("hm-file-frame");
        if (iframe) {
            iframe.contentWindow?.focus();
            iframe.contentWindow?.print();
        }
    };

    const handleOpenInNewTab = () => {
        window.open(url, "_blank");
    };

    return (
        <div className="hm-overlay" onClick={onClose}>
            <div className="hm-overlay-panel" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 860 }}>
                <button className="hm-overlay-close" onClick={onClose} style={{ top: 20, right: 20 }}>✕</button>
                <div style={{ padding: "20px 60px 0 24px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 16 }}>
                        <span className={`hm-card-type ${type}`} style={{ whiteSpace: "nowrap" }}>
                            {type === "prescription" ? "🩺" : type === "receipt" ? "🧾" : type === "report" ? "📁" : "📦"}{" "}
                            {title || type} {type !== "report" && id ? `— ${id}` : ""}
                        </span>
                        <button 
                            className="today-action-btn" 
                            onClick={handleOpenInNewTab}
                            style={{ fontSize: "12px", padding: "6px 12px", whiteSpace: "nowrap" }}
                        >
                            ↗️ Open in New Tab
                        </button>
                    </div>
                </div>
                <div style={{ padding: "16px 24px 0" }}>
                    {isPdf ? (
                        <iframe id="hm-file-frame" src={url} className="pdf-overlay-frame" title="File Viewer" style={{ height: "70vh" }} />
                    ) : (
                        <div style={{ 
                            height: "50vh", 
                            display: "flex", 
                            flexDirection: "column", 
                            alignItems: "center", 
                            justifyContent: "center",
                            background: "var(--hm-surface-hover)",
                            borderRadius: "12px",
                            border: "1px dashed var(--hm-border)",
                            gap: 16
                        }}>
                            <div style={{ fontSize: "64px" }}>📁</div>
                            <div style={{ textAlign: "center" }}>
                                <div style={{ fontSize: "18px", fontWeight: "600", color: "var(--hm-text)" }}>{title || "Clinical Report"}</div>
                                <div style={{ fontSize: "14px", color: "var(--hm-text-muted)", marginTop: 4 }}>
                                    This file type cannot be previewed directly.
                                </div>
                            </div>
                            <div style={{ display: "flex", gap: 12 }}>
                                <button className="today-action-btn" onClick={handleDownload}>⬇️ Download to View</button>
                                <button className="today-action-btn" onClick={handleOpenInNewTab}>↗️ Open in New Tab</button>
                            </div>
                        </div>
                    )}
                </div>
                <div className="pdf-overlay-actions">
                    {isPdf && <button className="today-action-btn" onClick={handlePrint}>🖨️ Print</button>}
                    <button className="today-action-btn" onClick={handleDownload}>⬇️ Download</button>
                    {onShare && (
                        <button className="today-action-btn hm-action-whatsapp-btn" onClick={onShare}>
                            <WhatsAppIcon /> Share on WhatsApp
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default HealthMapFileOverlay;
